import { Chip, Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
    menuListItem: {
        paddingTop: 0,
        paddingBottom: 0,
        border: "none",
    },
    menuItem: {
        maxHeight: 30,
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
}));

export function TagsKanbanContainer({ ticket }) {
    const classes = useStyles();
    const isMounted = useRef(true);

    const [tags, setTags] = useState([]);
    const [selected, setSelected] = useState("");

    useEffect(() => {
        isMounted.current = true;
        // Carrega tags kanban e já resolve o valor selecionado no mesmo ciclo
        loadTagsAndResolveSelected();

        return () => {
            isMounted.current = false;
        };
    }, [ticket?.id, ticket?.tags]);

    /**
     * Busca as tags kanban da API e, dentro do mesmo ciclo assíncrono,
     * cross-referencia com ticket.tags por ID para determinar qual está selecionada.
     * Isso garante que `tags` e `selected` são definidos juntos → um único re-render correto.
     */
    const loadTagsAndResolveSelected = async () => {
        try {
            const { data } = await api.get(`/tags/list`, { params: { kanban: 1 } });
            if (!isMounted.current) return;

            setTags(data);

            // Cross-reference por ID: não depende do campo `kanban` em ticket.tags
            if (ticket?.tags && ticket.tags.length > 0 && data.length > 0) {
                const kanbanIds = new Set(data.map(t => t.id));
                const ticketKanbanTag = ticket.tags.find(t => kanbanIds.has(t.id));
                setSelected(ticketKanbanTag ? ticketKanbanTag.id : "");
            } else {
                setSelected("");
            }
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (e) => {
        const value = e.target.value;
        // Remove tags kanban existentes do ticket (não toca em tags de atendimento)
        if (ticket.tags && ticket.tags.length > 0) {
            await api.delete(`/ticket-tags/${ticket.id}`);
        }
        if (value) {
            await api.put(`/ticket-tags/${ticket.id}/${value}`);
        }
        setSelected(value || "");
    };

    const renderSelectedValue = () => {
        const selectedTag = tags.find(tag => tag.id === selected);
        if (!selectedTag) return null;

        return (
            <Chip
                style={{
                    backgroundColor: selectedTag.color,
                    color: "#FFF",
                    marginRight: 1,
                    padding: 1,
                    fontWeight: 'bold',
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 50,
                    fontSize: "0.8em",
                    whiteSpace: "nowrap"
                }}
                label={selectedTag.name}
                size="small"
            />
        );
    };

    return (
        <>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="tag-kanban-id">{i18n.t("Etapa Kanban")}</InputLabel>
                <Select
                    labelWidth={60}
                    value={selected}
                    labelId="tag-kanban-id"
                    label={i18n.t("Etapa Kanban")}
                    onChange={onChange}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                    }}
                    renderValue={renderSelectedValue}
                >
                    <MenuItem value={null}>&nbsp;</MenuItem>
                    {tags.map(tag => (
                        <MenuItem key={tag.id} value={tag.id}>
                            {tag.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}
